import { MessagingPage } from "./MessagingPage";

export function MessagingPageRouter() {
  return <MessagingPage />;
}
